
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quiz/featured",
      function () {
        return require("private-next-pages/quiz/featured/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quiz/featured"])
      });
    }
  